import React from 'react';
import { withRouter } from 'react-router';
import {Nav, NavItem, Navbar, NavDropdown, MenuItem, Glyphicon} from 'react-bootstrap';
import styles from './sideBarMenu.css';
import NavBarMenu from './NavBarMenu';
import Header from './Header';
import  { LoginForm }   from '../login/LoginForm';
import { Logged, LoggedUserName } from '../login/Login';



class MasterPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false
    }

    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
  }

  onSetSidebarOpen = function(open) {
    this.setState({sidebarOpen: open});
  }

  getLekceStr(lekce) {
    var lekceStr = '';
    switch(lekce) {
      case '':
        lekceStr = 'nemáte žádný kredit'
        //pocetStyle = 'table-danger'
        break;
      case '1':
        lekceStr = ' lekce'
        break;
      case '2':
        lekceStr = ' lekce'
        break;
      case '3':
        lekceStr = ' lekce'
        break;
      case '4':
        lekceStr = ' lekce'
        break;
      default:
        lekceStr = ' lekcí'
        break;
    }
    return lekceStr;
  }

  render() {
    if (!Logged()) {
      return (
        <div id="">
          <Header/>
          <div>
            <LoginForm setUser={this.props.setUser} />
          </div>
        </div>
      );
    }

    var lekceStr = this.getLekceStr(this.state.kredit)
    return (
      <div id="">
        <Header setUser={this.props.setUser} />
        <div>
          <NavBarMenu setUser={this.props.setUser} />
          <div className="alert alert-info container mb-0 mt-2" role="alert">
            <h6><span className="d-none d-sm-inline">Přihlášený uživatel: </span>{LoggedUserName()}<span className="float-right">kredit: {this.props.kredit} {lekceStr}</span></h6>
          </div>
        </div>
      </div>
    );

    return (
      <div>
        <Header turnaj={this.props.turnaj} setUser={this.props.setUser} />
      </div>
    );

    return (
      <div id="sidebar-menu" className={styles.sideBarMenuContainer}>
          <Navbar fluid className={styles.sidebar} inverse >

              <Navbar.Header>
                  <Navbar.Brand>
                      <a href="/">User Name</a>
                  </Navbar.Brand>
                  <Navbar.Toggle />
              </Navbar.Header>

              <Navbar.Collapse>
                  <Navbar.Text className={styles.userMenu}>
                      <Navbar.Link href="#"><Glyphicon glyph="home"/></Navbar.Link>
                      <Navbar.Link href="#"><Glyphicon glyph="log-out"/></Navbar.Link>
                  </Navbar.Text>
                  <Nav>
                      <NavDropdown eventKey={1} title="Item 1">
                          <MenuItem eventKey={1.1} href="#">Item 1.1</MenuItem>
                      </NavDropdown>
                      <NavItem eventKey={2}>Item 2</NavItem>
                      <NavItem eventKey={3}>Item 3</NavItem>
                  </Nav>
              </Navbar.Collapse>

          </Navbar>
      </div>
    );
  }
}

export default withRouter(MasterPage);



// WEBPACK FOOTER //
// src/components/pages/MasterPage.js